import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, NgControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[formControlName][telephoneValidator], [telephoneValidator]'
})
export class TelephoneValidatorDirective implements OnInit, OnDestroy {
    valueSubscription!: Subscription;
    valid: boolean = false;
    required: boolean = false;

    constructor(public ngControl: NgControl) {}

    ngOnInit(): void {
        this.valueSubscription = this.ngControl.control!.valueChanges.subscribe((value) => {
            const newVal = this.transform(value);
            this.ngControl.control!.setValue(newVal, { emitEvent: false });
            this.required = this.ngControl.control!.hasValidator(Validators.required);

            this.valid ? null : this.ngControl.control!.setErrors({ invalidPhoneNumber: true });
        });
    }

    transform(value: any) {
        if (value === null || value === undefined) {
            this.valid = this.required ? false : true;
            return;
        }

        let rawNumbers = value.match(/\d/g);
        rawNumbers ? (rawNumbers = rawNumbers.join('')) : null;

        if (rawNumbers === null) {
            rawNumbers = '';
            this.valid = this.required ? false : true;
            return;
        }

        switch (rawNumbers.length) {
            case 0:
                this.valid = this.required ? false : true;
                break;
            case 1:
            case 2:
            case 3:
                if (value.slice(3, 4) == '-') {
                    rawNumbers = rawNumbers + '-';
                }
                this.valid = false;
                break;
            case 4:
            case 5:
            case 6:
                rawNumbers = rawNumbers.slice(0, 3) + '-' + rawNumbers.slice(3);
                if (value.slice(7, 8) == '-') {
                    rawNumbers = rawNumbers + '-';
                }
                this.valid = false;
                break;
            case 7:
            case 8:
            case 9:
            case 10:
                if (rawNumbers.length == 10) {
                    this.valid = true;
                } else {
                    this.valid = false;
                }
                rawNumbers = rawNumbers.slice(0, 3) + '-' + rawNumbers.slice(3, 6) + '-' + rawNumbers.slice(6);
                break;
            default:
                if (rawNumbers.length > 10) {
                    rawNumbers = rawNumbers.slice(0, 3) + '-' + rawNumbers.slice(3, 6) + '-' + rawNumbers.slice(6, 10);
                    this.valid = true;
                } else {
                    this.valid = false;
                }
                break;
        }

        return rawNumbers;
    }

    ngOnDestroy(): void {
        this.valueSubscription.unsubscribe();
    }
}
